<template>
	<div>
		<div class="table-responsive">
			<table class="table text-center" v-if="records.length > 0">
				<thead class="text-primary">
				<th>Username</th>
				<th>
					Password
				</th>
				<th style="width: 10%"></th>
				<th style="width: 10%"></th>
				</thead>
				<tbody>
				<tr v-for="record in records" v-if="record.id" :key="record.username" class="text-center">
					<th class="align-top">
						<input  v-if="record.id === editItem.id" autocomplete="off" type="text" class="form-control"  v-model="editItem.username"  :disabled="true"/>
						<span v-else>
							{{record.username}}
							<i class="fa fa-copy  btn btn-link text-primary" @click="doCopy(record.username)"></i>
						</span>
					</th>
					<th>
						<password v-if="record.id === editItem.id" :secureLength="8" :disabled="loading" v-model="editItem.password" autocomplete="off" defaultClass="form-control" :showPassword="true" :required="true" :badge="false" />
						<span v-else>
							{{record.password}}
							<i class="fa fa-copy btn btn-link text-primary" @click="doCopy(record.password)"></i>
						</span>
					</th>
					<th class="align-top">
						<div v-if="record.id === editItem.id">
							<button type="button" :disabled="loading" class="btn btn-outline-primary btn-round btn-sm" @click="update">
								<div class="loader small_loader" v-if="record.id === editItem.id && action === 'update'"></div>
								<i v-else class="fa fa-floppy-o"></i>
							</button>
						</div>
						<div v-else>
							<button type="button" :disabled="loading" class="btn btn-outline-primary btn-round btn-sm" @click="edit(record)">
								<i class="fa fa-pencil"></i>
							</button>
						</div>
					</th>
					<th class="align-top">
						<div v-if="record.id === editItem.id">
							<button type="button" class="btn btn-outline-danger btn-round  pull-right btn-sm" :disabled="loading" @click="cancel">
								<i class="fa fa-ban"></i>
							</button>
						</div>
						<div v-else>
							<button v-if="!record.primary" type="button" class="btn btn-outline-danger btn-round  pull-right btn-sm" :disabled="loading" @click="remove(record)">
								<div class="loader small_loader" v-if="record.id === removeItem.id && action === 'remove'"></div>
								<i v-else class="fa fa-times"></i>
							</button>
						</div>
					</th>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import validateMethods from "../../../../../mixins/validateMethods";
	import refreshToken from "../../../../../mixins/refreshTokenMixin";
	import tooltips from "../../../../../mixins/tooltips";
    import copyButtonMixin from "../../../../../mixins/copyButtonMixin";
	import zxcvbn from "zxcvbn";
	import _ from "lodash";
	import Password from "./PasswordStrengthMeter";

	export default {
		name: "FtpItems",
		props: {
			account: {
				type: Object,
				required: true
			},
			records: {
				type: Array,
				required: true
			},
			loading: {
				required: true
			},
			savesStatus: {
				required: true
			},
		},
		mixins: [validateMethods, refreshToken, tooltips, copyButtonMixin],
		data: function () {
			return {
				errors: [],
				editItem: {},
				removeItem: {},
				action: null,
				selected: [],
				ids: [],
				allSelected: false,
				search: ''
			}
		},
		components: {
			Password
		},
		computed: {
			userToken() {
				return this.$store.getters.getUserToken;
			},
		},
		watch: {
			savesStatus: function(){
				this.cancel();
				this.$emit('update:loading', false);
			}
		},
		methods: {
			edit(record) {
				this.editItem = Object.assign({}, record);
			},
			update() {
				this.errors = [];
				if (!this.editItem.username) {
					this.errors.push('Please fill username');
				}

				if (!this.editItem.password) {
					this.errors.push('Please fill password');
				}

				if (/\s/.test(this.editItem.password) || /\s/.test(this.editItem.username)) {
					this.errors.push('Please do not use spaces in your password or username');
				}

				let checkPasswordStrength = zxcvbn(this.editItem.password);
				if (checkPasswordStrength.score < 4) {
					this.errors.push(checkPasswordStrength.feedback.warning || "You need to enter a stronger password.");
				}

				if (this.errors.length) {
					swal({
						title: "Error message!",
						html: this.errors.join('<br/>'),
						type: "error"
					});
					return false;
				}

				this.action = 'update';
				this.$emit('update:loading', true);

				this.$http.post("ftp/update", {
					grant_type: "token",
					token: this.userToken,
					domain: this.account.domain,
					ip: this.account.ftp.host,
					username: this.editItem.username,
					password: this.editItem.password,
				})
					.then(() => {
						let records = this.records.map(item=>{
							if(item.id === this.editItem.id){
								return this.editItem;
							}
							return item;
						});
						this.$emit('update-list', records, "You have successfully updated the FTP account.");
					})
					.catch((err) => {
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}
						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: `Error updating FTP account. Message: ${responseMessage} Code: ${err.response.status}`,
							level: "danger"
						});
					})
					.finally(()=>{
						this.$emit('update:loading', false);
					});
			},
			remove(record) {
				swal({
					title: "Are you sure?",
					text: `Are you sure you want to delete this FTP account?`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.removeItem = record;
							this.action = 'remove';

							this.$emit('update:loading', true);

							this.$http.post("ftp/delete", {
								grant_type: "token",
								ip: this.account.ftp.host,
								token: this.userToken,
								username: record.username
							})
								.then(() => {
									this.$emit(
										'update-list',
										this.records.filter(item => item.id !== this.removeItem.id),
										"You successfully deleted FTP account"
									);
								})
								.catch((err) => {
									let responseMessage = err.response.data.message;
									if (err.response.status === 422) {
										responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
									}else if(err.response.status === 401){
										responseMessage = "You need update token. Please Try Again!";
										this.refreshToken();
									}
									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									});
									this.addLog({
										name: this.user.firstName + " " + this.user.lastName,
										message: `Error delete FTP account. Message: ${responseMessage} Code: ${err.response.status}`,
										level: "danger"
									});
									this.removeItem = {};
								})
								.finally(()=>{
									this.$emit('update:loading', false);
								});
						}
					});
			},
			cancel() {
				this.editItem = {};
				this.action = null;
				this.removeItem = {};
			}
		}
	}
</script>

<style>
	.loader.small_loader {
		width: 15px;
		height: 15px;
	}

	.item-type {
		width: 75px;
	}

	.item-to {
		width: calc(100% - 75px);
	}
	.table th{
		font-weight: normal;
	}
</style>